import React from "react";
import {
  type StyleProp,
  StyleSheet,
  View,
  type ViewStyle,
  useWindowDimensions,
} from "react-native";
import { Image } from "expo-image";

import UserImageLoading from "./UserImageLoading";

import { Spacings } from "@/styling/spacings";
import { type UserLikableImageMedia } from "@/schemas/user/image";

type Props = {
  userLikableImage: UserLikableImageMedia;
  numColumns?: number;
  isPixelated?: boolean;
  hasActionBar?: boolean;
  containerStyle?: StyleProp<ViewStyle>;
};

function UserImageBaseCard({
  userLikableImage,
  numColumns = 2,
  isPixelated = false,
  hasActionBar = false,
  containerStyle,
}: Props): React.JSX.Element {
  const { width } = useWindowDimensions();
  const itemWidth = (width - Spacings.s1 * (numColumns + 1)) / numColumns;
  const itemHeight = (itemWidth / 3) * 4;

  const styles = StyleSheet.create({
    container: {
      borderRadius: 7,
    },
    image: {
      height: itemHeight,
      resizeMode: "cover",
      width: "100%",
    },
  });

  return (
    <View
      style={[
        styles.container,
        { height: itemHeight, width: itemWidth },
        containerStyle,
      ]}
    >
      {isPixelated ? (
        <Image
          source={{ uri: userLikableImage.image.attributes.previewUrl }}
          style={styles.image}
          blurRadius={200}
          cachePolicy="memory-disk"
        />
      ) : (
        <UserImageLoading
          imageUrl={userLikableImage.image.attributes.previewUrl}
          width={itemWidth}
          height={itemHeight}
          {...(hasActionBar ? { borderRadiusBottom: 0 } : {})}
        />
      )}
    </View>
  );
}

export default UserImageBaseCard;
